import {
  INDIAN_STATES,
  CONTACT_STAGES,
  Verve_REQUIREMENTS,
  STATUS_COLORS,
  ADMIN_TABLE_HEADERS,
  TELECALLER_TABLE_HEADERS,
  INITIAL_CUSTOMER_FORM
} from "@/constants/globalConstants";
/*developer: Nithin
    date : 2024-06-19
    changes : Replaced Telecaller With Staff */

export const REFERENCE_SOURCES = [
  "Direct",
  "Facebook",
  "Instagram",
  "Youtube",
  "Whatsapp",
  "Website",
  "Just Dail",
  "Indiamart",
  "Google",
  "Call Center",
  "Walk In",
  "Sign Board",
  "Interior Designer",
  "Architect",
  "Friends",
  "News Paper",
  "Others",
];

export const PROPERTY_REQUIREMENTS_LEFT = [
  "Wardrobes",
  "Semi Modular Kitchen",
  "Interiors"
];

export const PROPERTY_REQUIREMENTS_RIGHT = [
  "Fully Modular Kitchen",
  "Appliances",
  "Designing & Estimate of Modular Kitchen"
];

export const PROPERTY_REQUIREMENTS_ALL = [
  ...PROPERTY_REQUIREMENTS_LEFT,
  ...PROPERTY_REQUIREMENTS_RIGHT
];

export {
  INDIAN_STATES,
  CONTACT_STAGES,
  Verve_REQUIREMENTS,
  STATUS_COLORS,
  ADMIN_TABLE_HEADERS,
  TELECALLER_TABLE_HEADERS,
  INITIAL_CUSTOMER_FORM
};
